import { useContent } from "src/components/App/Content"

import BackgroundImage from "src/assets/images/backgrounds/peoplevine-rsvp-bg-partner-green.png"

import "./PartnershipExpectationsSection.scss"
import ReactMarkdown from "react-markdown"
import Button from "src/components/Form/Button"

const PartnershipExpectationsSection = () => {
    const content = useContent('rsvp-partnership-expectations')
    const cardSection = content?.cards;
  return (
    <section className='partnership-expectation-section' style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className='container'>
        <div className='content-wrapper'>
          <h2 className='section-title'>Partnership Expectations</h2>
          {cardSection?.map((card, index) => (
            <div className={`content-block ${index === 1 ? 'reverse' : ''}`} key={`content-block-${index}`}>
                <div className="content-block__image">
                    <img src={card?.media?.url} alt="Partnership Expectations" />
                </div>
                <div className="content-block__text">
                    <ReactMarkdown className={'markdown'}>{card?.text ?? ""}</ReactMarkdown>
                </div>
            </div>
          ))}
          <Button to={'/rsvp-community-application-form'} className="section-button">Apply Now</Button>
        </div>
      </div>
    </section>
  )
}

export default PartnershipExpectationsSection
